<template>
  <div class="koyoukeiyaku">

    <div class="keiyaku-notes" v-if="!isLoadingSyainDetail">
      <div class="window-section">
        <h3>雇用契約に関する備考</h3>
        <div class="text">
          <p v-if="syainDetail.koyou_keiyaku_notes" class="pre">{{ syainDetail.koyou_keiyaku_notes }}</p>
          <p v-else @click="openNotesSyuuseiDialog()" class="input-button">備考を登録する</p>
        </div>

        <div class="control" v-if="syainDetail.koyou_keiyaku_notes">
          <p @click="openNotesSyuuseiDialog()"
            class="input-button">編集</p>
        </div>
      </div>
    </div>
    <template v-else>
      <loading :message="'読み込み中...'"></loading>
    </template>

    <div class="flex-container item-container">
      <template v-if="!isInit">
        <loading :message="'読み込み中...'"></loading>
      </template>

      <template v-else-if="syuugyouBasyoOptions.length > 0">
        <div>
          <select v-model="selectedSyuugyouBasyoOption">
            <option v-for="item in syuugyouBasyoOptions" :value="item">{{ item.label }}
            </option>
          </select>
        </div>

        <component v-if="selectedSyuugyouBasyoOption" :is="'detail'"
          :koyouKeiyakuId="selectedSyuugyouBasyoOption.koyou_id" :viewMode="true"
          :key="selectedSyuugyouBasyoOption?.koyou_id"></component>
      </template>

      <p v-else class="aligncenter">表示可能な雇用契約がありません</p>

      <modal :title="notesSyuuseiModalParts.title" ref="notesSyuuseiModalRef">
        <dialog-notes-syuusei :userId="userId" :syuuseiData="syuuseiData" @cancel="cancelNotesSyuusei"
          @send="sendNotesSyuusei">
        </dialog-notes-syuusei>
      </modal>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useForm } from "@/composable/form/form";
import { dateFormat } from "@/filters/common";
import Detail from "@/components/koyoukeiyaku/Detail.vue";
import { useRouter } from 'vue-router';
import { RouterConst } from "@/const/Router";
import { useSyuugyouBasyoInit } from "@/composable/syuubyoubasyo/init";
import { useNotesSyuuseiModal } from '@/composable/modal/koyoukeiyaku-notes-syuusei'
import NotesSyuusei from "@/components/syain/parts/KoyouKeiyakuNotesSyuusei.vue"
import { useSyainDetail } from "@/composable/syain/detail/init";
import OptionConst from "@/const/Option";

export default defineComponent({
  props: {
    userId: {
      type: Object as () => number | null,
      default: null,
    },
  },
  setup(props) {
    // 初期処理
    const { getError } = useForm();
    const router = useRouter();
    const { getSyuugyouBasyoOptionByUserId, syuugyouBasyoOptions, selectedSyuugyouBasyoOption, isLoading } = useSyuugyouBasyoInit();
    const notesSyuuseiModal = useNotesSyuuseiModal()
    const { userId, syainDetail, getSyainDetail, setUserId } = useSyainDetail()

    const isLoadingSyainDetail = ref(false)
    const isInit = ref(false)
    const isError = ref(false)
    onMounted(async () => {
      if (props.userId) {
        await setUserId(props.userId)
      }

      if (userId.value) {
        await loadSyaniDetail()
        // 就業場所取得
        // 社員マスタ＝ある社員の情報ハブとしての役割を考慮すると過去の雇用契約も見れておいたほうが良さそうなのでshowOldKeiyakuはtrue
        await getSyuugyouBasyoOptionByUserId(userId.value, true);
        selectedSyuugyouBasyoOption.value = syuugyouBasyoOptions.value[0]
      } else {
        isError.value = true
      }
      isInit.value = true
    })

    const editKoyouKeiyaku = () => {
      router.push({ name: RouterConst.KOYOUKEIYAKU_EDIT, query: { 
        id: selectedSyuugyouBasyoOption.value?.koyou_id, 
        mode: OptionConst.KOYOUKEIYAKU_EDIT_MODE.EDIT
      } })
    }

    // ダイアログ表示
    const openNotesSyuuseiDialog = async () => {
      if (!syainDetail.value) {
        return
      }
      await notesSyuuseiModal.setData(syainDetail.value)
      notesSyuuseiModal.openNotesSyuuseiModal()
    }

    // ダイアログ：キャンセル後
    const cancelNotesSyuusei = async () => {
      notesSyuuseiModal.closeNotesSyuuseiModal()
    }

    // ダイアログ：送信後
    const sendNotesSyuusei = async () => {
      notesSyuuseiModal.closeNotesSyuuseiModal()
      await loadSyaniDetail()
    }

    const loadSyaniDetail = async () => {
      isLoadingSyainDetail.value = true
      await getSyainDetail(userId.value)
      isLoadingSyainDetail.value = false
    }

    return {
      getError,
      dateFormat,
      editKoyouKeiyaku,
      isError,
      isLoading,
      syuugyouBasyoOptions,
      selectedSyuugyouBasyoOption,
      RouterConst,
      cancelNotesSyuusei,
      sendNotesSyuusei,
      openNotesSyuuseiDialog,
      notesSyuuseiModalRef: notesSyuuseiModal.notesSyuuseiModalRef,
      notesSyuuseiModalParts: notesSyuuseiModal.notesSyuuseiModalParts,
      syuuseiData: notesSyuuseiModal.syuuseiData,
      userId,
      syainDetail,
      isInit,
      isLoadingSyainDetail
    };
  },
  components: {
    "detail": Detail,
    'dialog-notes-syuusei': NotesSyuusei,
  },
});
</script>

<style lang="scss" scoped>
@import '@scss/components/syain-detail.scss';
</style>